const sessionKey = {
  redirect: "redirect",
} as const;

export { sessionKey };
